<template>
  <div class="">
    <div class="head-title">企业圈管理</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            后台企业统一发表企业圈，可以查看或批量删除员工企业圈，该功能可以在员工的名片中展现。
            <a
              class="help-link"
              href="https://www.weijub.com/index/index/news_detail?id=127"
              target="_blank"
              rel="noopener noreferrer"
              >使用教程</a
            >
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <nav class="navbar">
        <div class="nav-l">
          <el-button
            @click="tianjia()"
            icon="el-icon-s-promotion"
            type="primary"
          >
            发布
          </el-button>
        </div>
        <div>
          <el-input
            clearable
            placeholder="请输入名称搜索"
            style="width: 35.0rem; "
            prefix-icon="el-icon-search"
            v-model="input2"
            @change="rune()"
          >
          <el-button slot="append" type="primary" @click="rune()"
            >查询</el-button
          ></el-input>
        </div>


      </nav>
      <div style="width: 100%; margin-top: 2.0rem">
        <el-table
          :data="tableData.data"
          border
          style="width: 100%"
          v-loading="tableLoading"
          @selection-change="handleSelectionChange"

        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column
            prop="name"
            label="名称"
            style="width: 10%"
          ></el-table-column>
          <el-table-column
            prop="avatar"
            label="头像"
            style="width: 20%"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <el-image
                style="width: 3.2rem; height: 3.2rem"
                :src="scope.row.avatar"
                :preview-src-list="[scope.row.avatar]"
                fit="scale-down"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="if_enterprises_circle"
            label="是否展示企业圈"
            style="width: 10%"
            align="center"
          >
            <template slot-scope="scope">
              <!--  v-if="scope.row.if_enterprises_circle == 2" -->
              <div>
                <el-switch
                  v-model="scope.row.if_enterprises_circle"
                  :active-value="1"
                  :inactive-value="2"
                  @change="toggleStatus(scope.row)"
                >
                </el-switch>
              </div>
              <!-- <div v-if="scope.row.if_enterprises_circle == 1">
                <el-switch v-model="index3" disabled> </el-switch>
              </div> -->
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="300">
            <template slot-scope="scope">
              <el-button
                @click="bianji(scope.row.userid)"
                size="mini"
                type="text"
                >查看企业圈列表</el-button
              >
              <el-button
                @click="copyUrl(scope.row.userid)"
                size="mini"
                type="text"
                >复制链接</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="paging">
      <pagination
        :total="tableData.total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :page-sizes="[10,20,50,100]"
        :auto-scroll="false"
        @pagination="handleCurrentChange"
      />
    </div>
    <el-dialog title="添加" center :visible.sync="onSubmit" top="2%" width="32%">
      <!-- <div class="bule"></div> -->

      <el-form ref="form" :model="form" label-width="8.0rem">
        <el-form-item label="内容" prop="name">
          <el-input
            clearable
            type="textarea"
            autosize="true"
            v-model="form.name"
            placeholder="请输入您想发布的内容..."
          ></el-input>
        </el-form-item>
        <el-form-item label="上传">
          <el-upload
            class="upload-demo"
            :action="`${baseURL}/api/Alioss/uploadTotal`"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            multiple
            :limit="9"
            :on-exceed="handleExceed"
            :on-success="chenggong"
            :file-list="fileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png/video文件，且不超过500MB
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="(onSubmit = false), rel()">取 消</el-button>
        <el-button type="primary" @click="numoo()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="编辑" center :visible.sync="onSubmitn" width="30%">
      <!-- <div class="bule"></div> -->

      <el-form ref="form" :model="form" label-width="8.0rem">
        <el-form-item label="名称" prop="none">
          <el-input clearable v-model="bianjile">{{ bianjile }}</el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitn = false">取 消</el-button>
        <el-button type="primary" @click="numoon()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="配置密钥" center :visible.sync="onSubmitns" width="30%">
      <el-form ref="form" :model="form" label-width="15.0rem">
        <el-form-item label="查看企业圈密钥" prop="none">
          <el-input clearable v-model="miyao"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitns = false">取 消</el-button>
        <el-button type="primary" @click="tuisong()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" center title="查看图片">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
export default {
  name: "monitoring",
  inject: ["reload"],
  components: {
    Pagination,
  },
  data() {
    return {
      tableData: [],
      input2: "",
      onSubmit: false,
      onSubmitn: false,
      onSubmitns: false,
      index3: true,
      tableData_a: [],
      multipleSelection: [],
      value1: true,
      form: {
        name: "",
        none: "",
      },
      ele: "",
      yeshu: 1,
      bianjile: "",
      baseURL: this.axios.defaults.baseURL,
      fileList: [],
      url: "",
      imgs: [],
      miyao: "",
      listQuery: {
        page: 1,
        limit: 20,
      },
      dialogImageUrl: "",
      dialogVisible: false,
      tableLoading: true,
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.userTable();
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    rel() {
      this.reload();
    },
    tuisong() {
      this.axios
        .post(
          "/crm/CircleFriends/updateCircleSecret",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            circle_secret: this.miyao,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitns = false;
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    toggleStatus(e) {
      this.axios
        .post(
          "/crm/CircleFriends/ifEnterprisesCircle",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            userid: e.userid,
            if_enterprises_circle: e.if_enterprises_circle,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          } else if (res.data.code == 2) {
            this.onSubmitns = true;
          }
        })
        .catch(function (err) {});
    },
    copyUrl(e) {
      const input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      input.setAttribute(
        "value",
        `pages/friendCircle/friendCircle?account_id=${this.tooken.account_id}&userid=${e}`
      );
      document.body.appendChild(input);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$message.success("复制成功");
      }
      document.body.removeChild(input);
    },
    //  页数
    handleCurrentChange(val) {
      this.pageSize = val;
      this.userTable();
    },
    userTable() {
      this.axios
        .post(
          "/crm/KpiSet/getKpiUserss",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.input2,
            page: this.listQuery.page,
            number_page:this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableLoading = false;
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    rune() {
      this.userTable();
    },
    tianjia() {
      if (this.multipleSelection.length === 0) {
        this.$message.error("请先选择员工");
      } else {
        var arr = [];
        for (var a = 0; a < this.multipleSelection.length; a++) {
          arr.push(this.multipleSelection[a].userid);
        }
        this.form.none = arr.toString();
        this.onSubmit = true;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 修改
    numoon() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Source/editSource",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            account_id: this.tooken.id,
            name: this.bianjile,
            id: this.ele,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmitn = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
    },
    foren() {
      let arr = [];
      const data = new FormData();
      for (var a = 0; a <= this.fileList.length - 1; a++) {
        arr.push(this.fileList[a].file);
        data.append("file[]", this.fileList[a].file);
      }
      this.axios({
        method: "post",
        url: "/api/Alioss/uploadHost",
        data: data,
        headers: {
          "Content-Type":
            "multipart/form-data; boundary=----WebKitFormBoundaryPHA3DHO5JQHbHVkf",
        },
      })
        .then((res) => {
          this.url = res.data.data.url.toString();
        })
        .catch(function (err) {});
    },
    // 添加
    numoo() {
      this.foren();
      this.axios
        .post(
          "/crm/CircleFriends/addCircleAdmin",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            userids: this.form.none,
            url: this.url,
            content: this.form.name,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.reload();
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) {});
      this.rel();
    },
    bianji(e) {
      this.ele = e;
      this.$router.push({
        path: `/register/user/circleFriendadd?`,
        query: {
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          userid: e,
          url: this.url,
        },
      });
    },
    // 移除
    handleClick(e, o) {
      this.yeshu = 1;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/Source/delSource",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                id: e,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) {});
        })
        .catch(() => {});
    },
    chenggong(response, file, fileList) {
      var arr = [];
      fileList.map((i) => {
        arr.push(i.response.data.url);
      });
      this.url = arr.toString();
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {},
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 9 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, {
        type: "warning",
      });
    },
  },
};
</script>
<style scoped>
.hello {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}
nav {
  width: 100%;
}
.shij {
  display: inline-block;
  margin-right: 2.4rem;
}
.el-button--text{padding-left:.0rem !important;}
</style>
